
export default {
  page: {
    background: 'linear-gradient(135deg, #ffc84b 0%,#f78e78 25%,#ee7392 50%,#d685d5 75%,#90b6e7 100%)'
  },
  main: {
    color: '#D5367E',
  },
  estimatedDeliveryDateOrStatus: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '700',
    fontSize: '34px',
    lineHeight: '40px',
    color: '#32267D'
  },
  signatureRequired: {
    background: '#7FDAD4',
    color: '#000000'
  },
  auctaneBrand: {
    color: '#ffffff',
    filter: 'grayscale(1)'
  },
  custom1: {  // layout01 card
  },
  custom2: {  // layout01 card header
    color: '#32267D'
  },
  custom3: {  // layout01 recent tracking dot
    color: '#D5367E'
  }
};
